import React from 'react'
import { graphql } from 'gatsby'
import { get } from '../util/Mappers'
import { PostLink } from '../components/PostLink'
import { Layout } from '../components/Layout'
import { HomeHeader } from '../components/HomeHeader'
import { css } from 'emotion'
import { Card, Icon, Popup } from 'semantic-ui-react'
import Img from 'gatsby-image'
import logo from '../images/esmer-logo.svg'
import { siteMetadata } from '../../gatsby-config';

export const styles = {}
styles.container = css`
  display: flex;
  width: 100%;
`
styles.avatar = css`
  img {
    border-radius: 50%;
  }
  margin: auto;
`
styles.floatingMessage = css`
  position: fixed;
  top: 20px;
  right: 20px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  z-index: 100;
  opacity: 0.5;
  box-shadow: 0 0 12px black;
  i {
    margin: 0;
  }
  transition-property: opacity;
  transition-duration: 500ms;
  :hover {
    opacity: 1;
    transition-property: opacity;
    transition-duration: 500ms;
    cursor: help;
  }
`

const right = image => (
  <Card>
    <Img className={styles.avatar} fixed={image.childImageSharp.fixed} />
    <Card.Content>
      <Card.Header>Pablo Blanco</Card.Header>
      <Card.Meta>
        <span className="date">Author</span>
      </Card.Meta>
      <Card.Description>
        <p>
          Hey! I'm Pablo Blanco Celdrán, the author of this blog and I'm excited
          about the idea of making posts of my progress as an artist, game
          developer and person.
        </p>
        <p>
          I have few years of programming experience. I've been leader of some
          projects as full stack developer, and I have years of experimenting in
          the field at personal level. I'm trying to make my personal career
          grow towards a more artistic perspective.
        </p>
      </Card.Description>
    </Card.Content>
  </Card>
);

/**
 * Builds the metatags for the site's index.
 */
function buildMeta() {
  return [
    {
      property: 'og:url',
      content: 'https://esmer-games.github.io' + logo,
    },
    { property: 'og:title', content: siteMetadata.title },
    { property: 'og:description', content: siteMetadata.description },
    { property: 'og:type', content: 'article' },
    {
      property: 'og:image',
      content:
        'https://esmer-games.github.io' + logo,
    },
    { name: 'description', content: siteMetadata.description },
    { name: 'author', content: 'Pablo Blanco Celdrán' },
    {
      name: 'copyright',
      content: 'Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License'
    },
    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:title', content: siteMetadata.title },
    { name: 'twitter:description', content: siteMetadata.description },
    {
      name: 'twitter:image',
      content:
        'https://esmer-games.github.io' + logo,
    },
  ];
}

/**
 * Index page component.
 */
export default ({ data: { posts, avatar } }) => (
  <Layout
    header={HomeHeader}
    right={right(avatar)}
    meta={buildMeta()}
  >
    <Popup
      trigger={
        <div className={styles.floatingMessage}>
          <Icon name="exclamation triangle" size="large" inverted />
        </div>
      }
    >
      Some features like <b>pagination</b> are still
      under development! This warning will disappear when main functionalities
      are implemented.
    </Popup>
    {posts.edges.map(get`node`).map(post => (
      <PostLink {...post} key={post.id} />
    ))}
  </Layout>
)

export const query = graphql`
  query IndexQuery {
    avatar: file(relativePath: { eq: "avatar.jpg" }) {
      childImageSharp {
        fixed(width: 200, height: 200) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    posts: allMarkdownRemark(
      filter: { frontmatter: { skip: { ne: "yes" } } },
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          excerpt(pruneLength: 250)
          excerptShort: excerpt(pruneLength: 125)
          id
          meta: frontmatter {
            skip
            tags
            title
            date(formatString: "MMMM DD, YYYY [at] HH:MM")
            thumbnail {
              data: childImageSharp {
                fluid(maxHeight: 300, cropFocus: CENTER, quality: 90) {
                  ...GatsbyImageSharpFluid
                }
                fixed(width: 300, height: 300, cropFocus: CENTER, quality: 90) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
  }
`
